import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Coins } from 'lucide-react';
import EventStakeholdersTab from '../components/EventStakeholdersTab';

export default function AdminEventStakeholders() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background pt-20 pb-12" data-testid="admin-event-stakeholders">
      <div className="max-w-5xl mx-auto px-4">
        <Button variant="ghost" size="sm" onClick={() => navigate('/admin/events')} className="mb-2">
          <ArrowLeft className="w-4 h-4 mr-1" /> Back to events
        </Button>
        <div className="mb-6">
          <h1 className="text-3xl font-bold flex items-center gap-2 font-['Space_Grotesk']">
            <Coins className="w-7 h-7 text-fuchsia-400" /> Event Stakeholders
          </h1>
          <p className="text-sm text-muted-foreground mt-1">Configure the per-event NFT Ticket Offering for invited stakeholders.</p>
        </div>
        <EventStakeholdersTab eventId={eventId} />
      </div>
    </div>
  );
}
